import apiClient from './api';

// Call log, call detail, transcript and analysis (docs/design/contracts.md §7, A013).
// Filter parameters are repeated keys or comma-separated lists; `params` may hold arrays.
const toSearchParams = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === '') return;
    if (Array.isArray(value)) {
      if (value.length) search.append(key, value.join(','));
    } else {
      search.append(key, String(value));
    }
  });
  return search;
};

export const callsApi = {
  list: async (params) => {
    const response = await apiClient.get(`/calllog?${toSearchParams(params).toString()}`);
    return response.data;
  },
  classifications: async () => {
    const response = await apiClient.get('/calls/classifications');
    return response.data;
  },
  get: async (id) => {
    const response = await apiClient.get(`/calllog/${encodeURIComponent(id)}`);
    return response.data;
  },
  journey: async (id) => {
    const response = await apiClient.get(`/calllog/${encodeURIComponent(id)}/journey`);
    return response.data;
  },
  transcript: async (id) => {
    const response = await apiClient.get(`/calllog/${encodeURIComponent(id)}/transcript`);
    return response.data;
  },
  analysis: async (id) => {
    const response = await apiClient.get(`/calllog/${encodeURIComponent(id)}/analysis`);
    return response.data;
  },
  rerunAnalysis: async (id) => {
    const response = await apiClient.post(`/calllog/${encodeURIComponent(id)}/analysis/rerun`);
    return response.data;
  },
  setCommunity: async (id, body) => {
    const response = await apiClient.put(`/calllog/${encodeURIComponent(id)}/community`, body);
    return response.data;
  },
  deleteContent: async (id) => {
    const response = await apiClient.delete(`/calls/${encodeURIComponent(id)}/content`);
    return response.data;
  },
};

export { toSearchParams };
export default callsApi;
